import { boot } from 'quasar/wrappers';
import { Billing } from 'src/model/billing';
import { Db } from 'src/model/db/db';
import _ from 'lodash';

// Визуальные компоненты
import QCustomCheckbox from 'src/components/ui/QCustomCheckbox';
import NextCheckbox1 from 'components/next/NextCheckbox1';
import NextButton from 'components/next/NextButton';
import NextButton2 from 'components/next/NextButton2';

// Эмиттеры адаптогена
import mitt from 'mitt';

// import VueSocketIO from 'vue-3-socket.io';

export default boot(async ({ app }) => {
    window._ = _;

    /*
    const socketIo = new VueSocketIO({
        debug: true,
        connection: 'ws://146.120.224.57:53219',
    });
    app.use(socketIo);
     */

    // Биллинг
    app.config.globalProperties.$billing = new Billing(app.config.globalProperties);
    // Провайдер данных
    app.config.globalProperties.$db = new Db(app);
    app.config.globalProperties.$host = () => {
        let protocol = 'http://';
        if (window.location.hostname === 'sot.club') {
            protocol = 'https://';
        }
        return `${protocol}${window.location.hostname}`;
    };

    app.config.globalProperties.$q.isMobile = app.config.globalProperties.$q.platform.is.mobile;

    app.config.globalProperties.$emitter = mitt();

    // Кнопка
    app.component('QCustomCheckbox', QCustomCheckbox);
    app.component('NextCheckbox1', NextCheckbox1);
    app.component('NextButton', NextButton);
    app.component('NextButton2', NextButton2);
});

window.intervals = {};
window.intervals.delims = ['-', '...', '..'];
window.intervals.has = (text) => {
    const { delims } = window.intervals;
    for (let i = 0; i < delims.length; i += 1) {
        if (text?.includes(delims[i])) {
            return true;
        }
    }
    return false;
};

window.intervals.split = (text) => {
    if (!text) { return undefined; }
    const { delims } = window.intervals;
    for (let i = 0; i < delims.length; i += 1) {
        const delim = delims[i];
        if (text?.includes(delim)) {
            return text.split(delim).map((j) => (j || '').trim());
        }
    }
    return [text];
};

window.intervals.delim = (text) => {
    if (!text) { return undefined; }
    const { delims } = window.intervals;
    for (let i = 0; i < delims.length; i += 1) {
        const delim = delims[i];
        if (text?.includes(delim)) {
            return delim;
        }
    }
    return undefined;
};
